import styled from "styled-components";
import { engineApi } from "../../api/engine-api";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { deliveryState } from "../../app/reducers/delivery-slice";
import { DeliveryGroupType } from "../../types/schedule/delivery-group-type";
import AutoTrafficIcon from "../icons/AutoTrafficIcon";
import theme from "../../style/theme";

interface Props {
  onClick: () => void;
}

export const RouteOptimizationButton: React.FC<Props> = ({ onClick }) => {
  const dispatch = useAppDispatch();
  const { controlDeliveries } = useAppSelector(deliveryState);
  const filteredControlDeliveries = controlDeliveries.filter(
    (controlDelivery) => controlDelivery.type !== DeliveryGroupType.Split
  );

  const getPreview = async () => {
    try {
      const payload = controlDeliveries.map((controlDelivery) => {
        return {
          id: controlDelivery.delivery.id,
          type: controlDelivery.type,
        };
      });

      const response = await engineApi.pdptw({ deliverySegments: payload });
      //   dispatch(setPreviewAction({ previewDto: response.data }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Container onClick={onClick}>
      <IconWrapper>
        <AutoTrafficIcon fill="#075ee1" />
      </IconWrapper>
      <Label>동선 최적화</Label>
    </Container>
  );
};

const Container = styled.div`
  padding: 8px;
  width: fit-content;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border: 1px solid #075ee1;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;

  &:hover {
    background: ${theme.palette.primitives.gray50};
  }
`;

const IconWrapper = styled.div`
  display: flex;
  width: 14px;
  height: 14px;
  justify-content: center;
  align-items: center;
`;

const Label = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #075ee1;
  text-align: right;
  font-size: 13px;
  //   font-style: normal;
  font-weight: 600;
  //   line-height: normal;
  vertical-align: middle;
  text-align: center;
`;
